import React from 'react';
import { LinkAsButton, StatusDot } from '@printdeal/ui-library';
import { FormattedMessage, defineMessages } from 'react-intl';
import clsx from 'clsx';
import { PageLayout } from '../../../types/product/productDetailPage';
import { Message } from '../../../types/Message';

interface Props {
  pageLayout: PageLayout
}

const orderSteps: { [key: string ]: Message } = defineMessages({
  orderPreparation: {
    id: 'order.progress.step.orderPreparation',
    defaultMessage: 'Put together your product',
  },
  fileDelivery: {
    id: 'order.progress.step.fileDelivery',
    defaultMessage: 'Upload or create your design',
  },
});
const steps = Object.keys(orderSteps);

export const OrderProgress = ({ pageLayout }: Props) => (
  <div className="pd-w-full">
    <div className={clsx('pd-relative pd-z-10 pd-mt-6 pd-flex pd-items-start pd-gap-4 lg:pd-hidden',
      {
        'pd-ml-5': pageLayout === 'Easy',
      })}
    >
      {steps.map((step, index) => (
        <div className="pd-relative">
          <p className="pd-text-nowrap pd-text-sm pd-font-semibold">
            <LinkAsButton variant={index === 0 ? 'primary' : 'secondary'} disabled={index === 1}>
              <FormattedMessage
                id={orderSteps[step].id}
                defaultMessage={orderSteps[step].defaultMessage}
              />
            </LinkAsButton>
          </p>
        </div>
      ))}
    </div>

    <div className={clsx('pd-relative pd-z-10 pd-hidden pd-items-center lg:pd-flex',
      {
        'pd-my-10': pageLayout === 'Advanced',
        'pd-mb-6': pageLayout === 'Easy',
      })}
    >
      {steps.map((step, index) => (
        <div className={clsx('pd-relative pd-flex pd-flex-row-reverse',
          {
            'pd-w-1/3': index === 0,
            'pd-w-2/3': index === 1,
          })}
        >
          <div className="pd-absolute pd-top-[0.375rem] pd-h-2 pd-w-full pd-bg-dim-200">
            <div className={clsx('-pd-z-10 pd-size-full',
              {
                'pd-bg-primary-500': index === 0,
                'pd-bg-dim-200': index === 1 && pageLayout === 'Advanced',
                'pd-bg-white': index === 1 && pageLayout === 'Easy',
              })}
            />
          </div>

          <div className={clsx('pd-relative pd-z-10 pd-flex pd-flex-col pd-gap-2',
            {
              'pd-translate-x-1/2 pd-items-center': index === 0,
              'pd-items-end': index === 1,
            })}
          >
            <StatusDot variant={index === 0 ? 'primary' : 'dim'} className="pd-size-5 pd-border-2 pd-border-white" />
            <p className={clsx('pd-text-nowrap pd-text-md pd-font-bold',
              {
                'pd-text-primary-500': index === 0,
                'pd-text-dim-500': index === 1,
              })}
            >
              <FormattedMessage
                id={orderSteps[step].id}
                defaultMessage={orderSteps[step].defaultMessage}
              />
            </p>
          </div>
        </div>
      ))}
    </div>
  </div>
);
